import { Component, createRef } from 'react';
import { ICellRendererParams } from 'ag-grid-community';
import OverlayMenuButton from '@nkr/components/overlay-menu-button';
import { IRecipient } from '@nkr/models/index';
import { MatchStatus } from '@nkr/enums/index';
import { RecipientAction } from './recipient-action';
import { menuItemList } from './menu-item-list';

export const getUrl = (isAdmin: boolean, action: RecipientAction, id: number, data: IRecipient) => {
    let hrefPrefix = isAdmin ? '/admin/follow-up' : `/center/${data.centerId}/follow-up`;
    let recpTab = data.matchStatusId == MatchStatus.Transplanted ? `post-transplant` : `general`;

    switch (action) {
        case RecipientAction.Edit: return `/center/${data.centerId}/recipient/${data.id}/profile/${recpTab}`;
        case RecipientAction.ToolBox: return `/center/${data.centerId}/recipient/${data.id}/toolbox`;
        case RecipientAction.PairedDonors: return `/center/${data.centerId}/recipient/${data.id}/profile/paired-donors`;
    }

    return null;
}

export const getMenuItems = () => {
    let menuItems = [
        RecipientAction.Edit,
        RecipientAction.ToolBox,
        RecipientAction.PairedDonors
    ];

    return menuItems;
}

interface IProps {
    data: IRecipient,
    isAdmin: boolean,
    pullRight?: boolean,
    onMenuDisplayed?: (id: number) => void,
    onMenuToggle: (show: boolean) => void,
    onItemSelected: (id: number, action: RecipientAction) => void
}

export class ActionButtonRenderer extends Component<ICellRendererParams & IProps, {}> {
    myDropdown: any = createRef();

    componentDidMount = () => {
    }

    handleMenuToggle = (show: boolean) => {
        this.props.onMenuToggle(show);
    };

    handleMenuSelection = (id: any, action: number) => {
        this.props.onItemSelected(id, action);
    }

    getUrl = (action: RecipientAction, id: number) => {
        let data = this.props.data as IRecipient;
        return getUrl(this.props.isAdmin, action, id, data);
    }

    getMenuItems = () => {
        return getMenuItems();
    }

    render = () => {

        const menuItems = this.getMenuItems().map(item => {
            return menuItemList.find(x => x.action == item);
        });

        const menu = menuItems.map(item => {
            let url = item.action != -1 ? this.getUrl(item.action, this.props.data.id) : null;
            let id = item.action >= 0 ? this.props.data.id : 'div-' + this.props.data.id + '-' + Math.random() * 10000;

            return { id, action: item.action, include: true, selectable: false, element: <a href={url}>{item.title}</a>, url, title: item.title };
        });

        return (
            <OverlayMenuButton
                menu={menu}
                bsStyle='primary'
                bsSize='xs'
                title='Actions'
                listItemStyle={{ padding: '2px 7.5px', fontSize: 14 }}
                includeCaret={true}
                onToggle={this.handleMenuToggle}
                onSelect={this.handleMenuSelection}
            />
        );
    }
}